export enum EditorAction {
  OpenTextDrawer = 'editor/openTextDrawer',
  CloseTextDrawer = 'editor/closeTextDrawer',
  OpenImageEditToolbar = 'editor/openImageEditToolbar',
  CloseImageEditToolbar = 'editor/closeImageEditToolbar',
  SetImageEditToolbarActiveTool = 'editor/setImageEditToolbarActiveTool',
  OpenFontToolbar = 'editor/openFontToolbar',
  CloseFontToolbar = 'editor/closeFontToolbar',
  SetFontToolbarActiveTool = 'editor/setFontToolbarActiveTool',
  CloseAllDrawers = 'editor/closeAllDrawers',
  CloseAllToolbars = 'editor/closeAllToolbars',
}

export type ImageEditToolbarTool = 'scale' | 'rotate' | 'order' | 'crop';

export type FontToolbarInlineTool = 'font-family' | 'font-size' | 'alignment' | 'color' | 'position';

export interface EditorState {
  isTextDrawerOpen: boolean;
  isImageEditToolbarOpen: boolean;
  imageEditToolbarActiveTool: ImageEditToolbarTool | null;
  isFontToolbarOpen: boolean;
  fontToolbarActiveTool: FontToolbarInlineTool | null;
}

export interface EditorActions {
  openTextDrawer: () => void;
  closeTextDrawer: () => void;
  openImageEditToolbar: () => void;
  closeImageEditToolbar: () => void;
  setImageEditToolbarActiveTool: (tool: ImageEditToolbarTool | null) => void;
  openFontToolbar: () => void;
  closeFontToolbar: () => void;
  setFontToolbarActiveTool: (tool: FontToolbarInlineTool | null) => void;
  closeAllDrawers: () => void;
  closeAllToolbars: () => void;
}

export type EditorSlice = EditorState & EditorActions;
